import {
  Component, Input, OnChanges, OnInit, SimpleChanges
} from '@angular/core';
import {NgClassType} from "../../model/common.model";
import {NgClass, NgIf} from "@angular/common";
import {NumberRound} from "../number-round.directive";

@Component({
  selector: 'uptime-view',
  templateUrl: './uptime-view.component.html',
  imports: [
    NgIf,
    NumberRound,
    NgClass
  ],
  standalone: true
})
export class UptimeViewComponent implements OnInit, OnChanges {

  @Input() seconds?: number
  @Input() dateRange?: {
    start: Date | string,
    end: Date | string
  }
  @Input() greedy?: boolean
  @Input() ngClass?: NgClassType

  constructor() { }

  ngOnInit(): void {
    this.invalidate()
  }

  ngOnChanges(_: SimpleChanges): void {
    if (this.greedy === true) {
      this.invalidate()
    }
  }

  invalidate(): void {
    if (this.dateRange) {
      try {
        let startDate = new Date(this.dateRange.start)
        let endDate = new Date(this.dateRange.end)
        this.seconds = (endDate.getTime() - startDate.getTime()) / 1000
      }
      catch (e) {
        console.error('error converting date range to milliseconds', e)
      }
    }
  }
}
